var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.4635,
    height: 49.4936,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0121 18.6357C29.8312 18.7955 30.6442 19.1567 31.2343 19.7468C31.8244 20.3369 32.1856 21.15 32.3454 21.969M29.5677 14.7468C31.2694 14.9359 32.8007 15.7591 34.0121 16.969C35.2235 18.179 36.0431 19.712 36.2343 21.4135M36.2337 29.7209V32.7318C36.2384 33.8827 35.2035 34.8438 34.0415 34.739C24.0122 34.7468 16.2344 26.8968 16.2422 16.9348C16.1376 15.779 17.0939 14.748 18.2434 14.7469H21.2602C21.7482 14.7421 22.2214 14.9146 22.5914 15.2322C23.6434 16.1352 24.3201 19.1999 24.0597 20.4182C23.8565 21.3695 22.8976 22.0349 22.2457 22.6855C23.6772 25.1981 25.7618 27.2785 28.2793 28.7072C28.9312 28.0566 29.598 27.0997 30.5511 26.8968C31.7738 26.6366 34.8582 27.3142 35.7576 28.3735C36.0765 28.7492 36.2459 29.2287 36.2337 29.7209Z",
    stroke: "#DA1F3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/footer-phone.29b4591f8d5c041b7628684c0149c4ae.svg";
export { ForwardRef as ReactComponent };